import React from 'react';
import type { CmsSectionData } from './types';
import HeroSection from '../sections/HeroSection';
import PainTechSection from '../sections/PainTechSection';
import ExpertSection from '../sections/ExpertSection';
import ProductFunnelSection from '../sections/ProductFunnelSection';
import StoreLocatorSection from '../sections/StoreLocatorSection';
import AboutUs from '../components/AboutUs';
import Principles from '../components/Principles';
import Authentic from '../components/Authentic';
import CaseStudies from '../components/CaseStudies';
import Footer from '../components/Footer';
import PainPointFinder from '../components/PainPointFinder';

interface CmsSectionProps {
  section: CmsSectionData;
}

const sectionComponents: Record<string, React.FC<{ content: Record<string, unknown> }>> = {
  hero: HeroSection,
  'pain-tech': PainTechSection,
  'pain-points': PainPointFinder as React.FC<{ content: Record<string, unknown> }>,
  about: AboutUs as React.FC<{ content: Record<string, unknown> }>,
  principle: Principles as React.FC<{ content: Record<string, unknown> }>,
  experts: ExpertSection,
  'product-funnel': ProductFunnelSection,
  authentic: Authentic as React.FC<{ content: Record<string, unknown> }>,
  cases: CaseStudies as React.FC<{ content: Record<string, unknown> }>,
  'store-locator': StoreLocatorSection,
  footer: Footer as React.FC<{ content: Record<string, unknown> }>,
};

const CmsSection: React.FC<CmsSectionProps> = ({ section }) => {
  if (!section.isActive) return null;

  const Component = sectionComponents[section.key];
  if (!Component) {
    console.warn(`No renderer for CMS section: ${section.key}`);
    return null;
  }

  return <Component content={section.contentJson} />;
};

export default CmsSection;
